module.exports = __webpack_public_path__ + "static/media/Man-Wprosthetic-Workout.f5c6a3a0.png";